// extracted by mini-css-extract-plugin
module.exports = {"container":"MarketHcpRow__container___3amfb","col":"MarketHcpRow__col___Ly-eO","title-col":"MarketHcpRow__title-col___2aV8n"};